import type { FallbackLocale, Region } from '@klarna-web-sdk/lib/src/sdk/types'

export type LocaleMapping = {
  [key in Lowercase<Region>]: FallbackLocale
}

export const RegionalLocaleMapping: LocaleMapping = {
  eu: 'en-GB',
  na: 'en-US',
  oc: 'en-AU',
}
